import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, timer, Subject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IdleService {

  private idleTimeout = 120 * 60 * 1000;  // 1 minute
  private warningTime = 15 * 1000;      // last 15 seconds
  private stopWarning = false;
  private stopTimeout = false;
  private lastActivityTime = Date.now();

  private warningSubject = new Subject<number>();
  private timeoutSubject = new Subject<void>();

  warning$ = this.warningSubject.asObservable();
  timeout$ = this.timeoutSubject.asObservable();

  constructor(private ngZone: NgZone) { }

  startWatching() {
    this.ngZone.runOutsideAngular(() => {

      // detect activity
      const activityEvents = merge(
        fromEvent(window, 'mousemove'),
        fromEvent(window, 'keydown'),
        fromEvent(window, 'click'),
        fromEvent(window, 'touchstart'),
        fromEvent(window, 'scroll')
      );

      activityEvents.pipe(
        debounceTime(300),
        tap(() => this.resetTimer())
      ).subscribe();

      // loop to check idle time
      this.checkLoop();
    });
  }

  private resetTimer() {
    this.lastActivityTime = Date.now();
  }

  extendSession() {
    this.stopWarning = true;
    this.stopTimeout = true;

    setTimeout(() => {
      this.stopWarning = false;
      this.stopTimeout = false;
    }, 100); // allow previous cycle to finish

    this.lastActivityTime = Date.now();
  }

  private checkLoop() {
    timer(0, 1000).subscribe(() => {
      const now = Date.now();
      const inactiveFor = now - this.lastActivityTime;

      // send countdown warning
      if (
        inactiveFor >= this.idleTimeout - this.warningTime &&
        inactiveFor < this.idleTimeout
      ) {
        const remaining = Math.round((this.idleTimeout - inactiveFor) / 1000);
        this.warningSubject.next(remaining);
      }

      // full timeout
      if (inactiveFor >= this.idleTimeout) {
        if (!this.stopTimeout) {
          this.timeoutSubject.next();
        }
      }
    });
  }
}
